import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#1a365d] text-white py-12" data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-91">
          <div data-id="element-92">
            <h3 className="text-2xl font-bold mb-4" data-id="element-93">Jesús Silva</h3>
            <p className="text-gray-300" data-id="element-94">
              {t('Agente de Seguros de Protección Integral', 'Comprehensive Protection Insurance Agent')}
            </p>
          </div>
          <div data-id="element-95">
            <h4 className="text-lg font-semibold mb-4" data-id="element-96">
              {t('Contacto', 'Contact')}
            </h4>
            <div className="space-y-3" data-id="element-97">
              <a href="https://wa.me/13469022090" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-300 hover:text-[#d97706] transition-colors" data-id="element-98">
                <PhoneIcon className="w-5 h-5" data-id="element-99" />
                (346) 902-2090
              </a>
              <a href="mailto:jsilvainsurance@gmail.com" className="flex items-center gap-2 text-gray-300 hover:text-[#d97706] transition-colors" data-id="element-100">
                <MailIcon className="w-5 h-5" data-id="element-101" />
                jsilvainsurance@gmail.com
              </a>
            </div>
          </div>
          <div data-id="element-102">
            <h4 className="text-lg font-semibold mb-4" data-id="element-103">
              {t('Servicios', 'Services')}
            </h4>
            <ul className="space-y-2 text-gray-300" data-id="element-104">
              <li data-id="element-105">{t('Planes de Salud', 'Health Plans')}</li>
              <li data-id="element-106">{t('Seguros de Vida', 'Life Insurance')}</li>
              <li data-id="element-107">{t('Seguros de Accidentes', 'Accident Insurance')}</li>
              <li data-id="element-108">Medicare</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} Jesús Silva.{' '}
            {t('Todos los derechos reservados.', 'All rights reserved.')}
          </p>
          <div className="flex items-center gap-4" data-id="element-111">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-112">
              {t('Política de Privacidad', 'Privacy Policy')}
            </Link>
            <span data-id="element-113">|</span>
            <a href="/#contacto" className="hover:text-white transition-colors" data-id="element-114">
              {t('Contacto', 'Contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}